<script>
import errorsMixin from '@/mixins/errors.mixin'

export default {
  render() {
    return this.$scopedSlots.default({
      processing: this.processing,
      assign: this.assign
    })
  },

  inject: {
    parentSvc: 'svc'
  },
  
  mixins: [errorsMixin],

  data: () => ({
    processing: false
  }),

  methods: {
    async assign({ID, leaders = []}) {
      try {
        this.processing = true;
        await this.parentSvc.updateCourse(ID, {leaders});
        this.$notify({text: 'Updated', type: 'success'});
        this.processing = false;
      } catch (error) {
        this.processing = false;
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
    }
  }
}
</script>
